(function () {
  'use strict';
  function normalize(text) {
    return String(text || '').replace(/[’′`]/g, "'").replace(/[”″]/g, '"').replace(/×/g, 'x').trim();
  }
  function dimension(text) {
    var value = normalize(text).replace(/(\d+(?:\.\d+)?)\s*(?:feet|foot|ft)\s*(\d+(?:\.\d+)?)\s*(?:inches|inch|in)\.?$/i, "$1'$2\"").replace(/\s+/g, '').replace(/(?:ft|feet|foot)\.?$/i, "'").replace(/(?:inches|inch|in)\.?$/i, '\"');
    var feet = value.match(/^(\d+(?:\.\d+)?)'(\d+(?:\.\d+)?)?['\"]*$/);
    var result = feet ? Number(feet[1]) * 12 + Number(feet[2] || 0) : /^\d+(?:\.\d+)?\"$/.test(value) ? parseFloat(value) : /^\d+(?:\.\d+)?$/.test(value) ? Number(value) * 12 : null;
    return Number.isFinite(result) && result > 0 ? result : null;
  }
  function parse(text, shapeHint) {
    var source = normalize(text);
    var shape = /round/i.test(source) ? 'round' : /oval/i.test(source) ? 'oval' : shapeHint || 'rect';
    var part = '(\\d+(?:\\.\\d+)?(?:\\s*\'\\s*\\d*(?:\\.\\d+)?\\s*["\']?|\\s*"|\\s*(?:ft|feet|foot|inches|inch|in))?)';
    var pair = source.match(new RegExp(part + '\\s*x\\s*' + part, 'i'));
    var w, l;
    if (pair) {
      w = dimension(pair[1]); l = dimension(pair[2]);
      if (/\bcm\b/i.test(source)) { w = parseFloat(pair[1]) / 2.54; l = parseFloat(pair[2]) / 2.54; }
    } else if (shape === 'round') {
      var round = source.match(new RegExp(part + '\\s*(?:ft|feet|foot)?\\s*round', 'i'));
      if (round) w = l = dimension(round[1]);
    }
    return w > 0 && l > 0 ? {w: Math.min(w, l), l: Math.max(w, l), shape: shape} : null;
  }
  function covers(size, fit) {
    return !!(size && fit && size.shape === fit.shape && size.w + .001 >= fit.w && size.l + .001 >= fit.l);
  }
  function constrain(select, fit) {
    Array.from(select.options).forEach(function (option) {
      if (!option.value) return;
      if (option.dataset.rugiUnavailable === undefined) option.dataset.rugiUnavailable = String(option.disabled);
      option.disabled = option.dataset.rugiUnavailable === 'true';
    });
  }
  function choose(options, fit) {
    if (!fit) return null;
    return options.filter(function (option) {
      var size = option.size;
      return !option.disabled && covers(size, fit);
    }).sort(function (a, b) {
      return a.size.w * a.size.l - b.size.w * b.size.l || a.price - b.price;
    })[0] || null;
  }
  function formatDimension(inches) {
    var rounded = Math.round(inches * 100) / 100, feet = Math.floor(rounded / 12), rest = Math.round((rounded - feet * 12) * 100) / 100;
    return feet + "'" + (rest ? rest + '"' : '');
  }
  function describe(fit) {
    if (!fit) return '';
    if (fit.shape === 'round') return formatDimension(fit.w) + ' round';
    return formatDimension(fit.w) + ' x ' + formatDimension(fit.l) + (fit.shape === 'oval' ? ' oval' : '');
  }
  function fitFromData(root, label) {
    var shape = root.dataset.rugShape || (root.dataset.rugRound === 'true' ? 'round' : 'rect');
    var fit = parse(label, shape) || parse(root.dataset.rugSize, shape);
    if (fit) fit.measured = false;
    var width = Number(root.dataset.rugVariantW), length = Number(root.dataset.rugVariantL);
    if (!(width > 0 && length > 0) && root.dataset.rugSingle !== 'false') {
      width = Number(root.dataset.rugW); length = Number(root.dataset.rugL);
    }
    if (width > 0 && length > 0) fit = {w: Math.min(width, length), l: Math.max(width, length), shape: fit ? fit.shape : shape, measured: true};
    return fit;
  }
  function cutSize(fit) {
    if (!fit || fit.w <= 3 || fit.l <= 3) return null;
    return {w: fit.w - 3, l: fit.l - 3, shape: fit.shape, measured: !!fit.measured};
  }
  function shortName(title, material) {
    var name = String(title || 'Rug').split('|')[0].replace(/\d+(?:\.\d+)?(?:['’]\d*["”']?)?\s*[x×]\s*\d+(?:\.\d+)?(?:['’]\d*["”']?)?/gi, '').replace(/\b(?:ft|feet)\b/gi, '').replace(/\s+/g, ' ').trim();
    if (/wool/i.test(material || title) && !/wool/i.test(name)) name = name.replace(/\brug\b/i, 'wool rug');
    return name;
  }
  window.RugiPadSizing = {parse: parse, parseDimension: dimension, covers: covers, constrain: constrain, choose: choose, describe: describe, fitFromData: fitFromData, cutSize: cutSize, shortName: shortName};
  function updateProduct(root, variant, keepSelection) {
    var select = root.querySelector('[data-rugi-pad-select]');
    if (!select || !root.__rugi) return;
    var labels;
    try { labels = JSON.parse(root.dataset.variantLabels || '[]'); } catch (error) { labels = []; }
    var form = root.closest('form'), input = form && form.querySelector('[name="id"]');
    var id = variant && variant.id || input && input.value;
    if (variant && labels.length && !labels.some(function (item) { return String(item.id) === String(variant.id); })) return;
    var selected = labels.find(function (item) { return String(item.id) === String(id); }) || variant;
    root.dataset.rugVariantW = selected && selected.w || '';
    root.dataset.rugVariantL = selected && selected.l || '';
    if (!root.dataset.originalRugTitle) root.dataset.originalRugTitle = root.dataset.rugTitle;
    if (!root.dataset.originalRugSku) root.dataset.originalRugSku = root.dataset.rugSku || '';
    if (selected && selected.sku !== undefined) root.dataset.originalRugSku = selected.sku || '';
    var fit = fitFromData(root, selected && selected.title), cut = cutSize(fit);
    constrain(select, cut);
    var options = Array.from(select.options).filter(function (option) { return option.value; }).map(function (option) {
      return {id: option.value, size: parse(option.dataset.title), price: Number(option.dataset.price), disabled: option.disabled};
    });
    var match = choose(options, cut);
    if (!keepSelection) select.value = match ? match.id : '';
    var purpose = root.querySelector('[data-rugi-pad-purpose]');
    var chosen = select.selectedOptions[0], chosenSize = chosen && parse(chosen.dataset.title);
    var smaller = cut && chosen && chosen.value && !covers(chosenSize, cut);

    var other = purpose && purpose.value === 'other';
    var cheapMachine = root.dataset.rugMachine === 'true' && selected && Number(selected.price) < 30000;
    root.hidden = !!cheapMachine;
    var check = root.querySelector('[data-rugi-pad-check]');
    check.disabled = !!cheapMachine || !!(smaller && !other);
    if (check.disabled) check.checked = false;
    root.dataset.rugTitle = other ? 'Another rug (leave uncut)' : shortName(root.dataset.originalRugTitle, root.dataset.rugMaterial);
    root.dataset.rugSku = other ? '' : root.dataset.originalRugSku;
    root.__rugiFit = other ? 'Leave uncut; for another rug' : cut && fit.measured ? describe(cut) + ' (1.5 inch inset on every edge)' : 'Confirm actual rug measurements before cutting';
    root.classList.toggle('rugi-pad--nosize', !(chosen && chosen.value));
    root.querySelector('[data-rugi-pad-meta]').textContent = smaller && !other ? 'This pad size is too small for this rug. Choose a larger stock size, or select another rug below.' : other ? 'Durahold Plus for another rug. Supplied uncut.' : cut && fit.measured ? 'Durahold Plus, cut to ' + describe(cut) + ' (1½″ in from each edge).' : 'Durahold Plus. Confirm actual rug measurements before custom cutting.';
    root.querySelector('[data-rugi-pad-price]').textContent = chosen && chosen.value ? '+ ' + chosen.dataset.money : '';
    if (!(chosen && chosen.value)) root.querySelector('[data-rugi-pad-check]').checked = false;
  }
  function scan() {
    document.querySelectorAll('[data-rugi-cart-label]').forEach(function (root) {
      var kind = root.dataset.kind, text;
      if (kind === 'pad') {
        text = String(root.dataset.rugTitle || '').split('|')[0].replace(/custom[ -]?cut/gi, '').replace(/\s+/g, ' ').trim();
        if (root.dataset.rugLabel && root.dataset.rugLabel !== 'Default Title') text += ' · ' + root.dataset.rugLabel;
      } else if (['one','rug','brand'].indexOf(kind) !== -1) {
        text = shortName(root.dataset.rugTitle, root.dataset.rugMaterial);
        var fit = fitFromData(root, root.dataset.rugLabel);
        if (fit && fit.measured) text += ' · ' + describe(fit);
        else if (root.dataset.rugLabel && root.dataset.rugLabel !== 'Default Title') text += ' · ' + root.dataset.rugLabel;
      }
      if (text && root.textContent !== text) root.textContent = text;
    });
    document.querySelectorAll('[data-rugi-pad]').forEach(function (root) {
      if (!root.dataset.rugiSizingReady && root.__rugi) { root.dataset.rugiSizingReady = 'true'; updateProduct(root); root.querySelectorAll('[data-rugi-pad-select],[data-rugi-pad-purpose]').forEach(function (control) { control.addEventListener('change', function () { updateProduct(root, null, true); }); }); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('variant:changed', function (event) {
    document.querySelectorAll('[data-rugi-pad]').forEach(function (root) { updateProduct(root, event.detail && event.detail.variant); });
  });
  document.addEventListener('shopify:section:load', scan);
  var pending;
  new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(scan, 80); }).observe(document.documentElement, {childList:true,subtree:true});
})();



